import React from "react"
import useVars from "./Stores/useVars.jsx"

import useIntro from "./Stores/useIntro.jsx"

export default function Introduction() {
    const varsState = useVars()
    const introState = useIntro()

    function HideInterface() {
        // let instructions = document.getElementById('instructions')
        // musicTrack.play()

        // instructions.style.display = "none";
        varsState.startGame()
        console.log(varsState.phase)
    }

    return  varsState.phase == 'ready' ? <div className="introduction">

    {/* INSTRUCTIONS PANEL */}
        <div className="main-body">
                Welcome to
                <div className="title">Two Minute Town</div>
                <div className="description">
                    The goal of the game is to earn as many
                    <div style={{color:"#9747FF", fontWeight: '700',display: 'flex'}}>victory points <img src="icons/04-victory-points.svg" style={{width:'20px'}}/></div>
                    as possible within 2 minutes by building
                    <div style={{color:'#2C84C3', fontWeight: '700',display: 'flex'}}>developments <img src="icons/02-buildings.svg" style={{width:'20px'}}/></div>
                    and earning
                    <div style={{color:'#0E8E0B', fontWeight: '700',display: 'flex'}}>money <img src="icons/01-money.svg" style={{width:'20px'}}/></div>.
                    (<div style={{color:"#9747FF", fontWeight: '700',display: 'flex'}}>Victory points <img src="icons/04-victory-points.svg" style={{width:'20px'}}/></div>
                    = total income)
                </div>
                <button onClick={HideInterface}>Play Game</button>
            </div>

            <div className="footer">
                Music is Galaxy by Sulyya.
            </div>
    </div> : <></>
}